import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/storefront/Navbar';
import Footer from '../components/storefront/Footer';
import supabase from '../supabase/supabase';
import { FiXCircle, FiRefreshCw } from 'react-icons/fi';

const PaymentCancel = () => {
  const navigate = useNavigate();
  const [retrying, setRetrying] = useState(false);

  // Extract from raw URL in case it's placed before the hash
  const fullUrl = window.location.href;
  const match = fullUrl.match(/[?&]order_id=([^&#]*)/);
  const orderId = match ? decodeURIComponent(match[1]) : null;

  const handleRetry = async () => {
    if (!orderId) {
      navigate('/checkout');
      return;
    }
    setRetrying(true);
    try {
      const { data, error } = await supabase.functions.invoke('marx-create-order', {
        body: { orderId, originUrl: window.location.origin }
      });

      if (error) throw error;
      if (data?.paymentUrl) {
        window.location.href = data.paymentUrl;
      }
    } catch (err) {
      alert('Failed to retry payment. Please try again.');
      setRetrying(false);
    }
  };

  return (
    <div className="bg-brand-sand min-h-screen font-sans flex flex-col">
      <Navbar />
      <div className="flex-1 flex items-center justify-center p-6 mt-20">
        <div className="bg-white/80 backdrop-blur-xl p-10 rounded-3xl border border-white shadow-xl max-w-lg w-full text-center animate-in zoom-in duration-500">
          <div className="w-20 h-20 bg-red-50 rounded-full flex items-center justify-center text-red-400 mb-6 border-4 border-white shadow-lg mx-auto">
            <FiXCircle className="w-10 h-10" />
          </div>
          <h1 className="text-3xl font-serif text-brand-darkSage mb-2">Payment Cancelled</h1>
          <p className="text-brand-lightText mb-8">Your transaction was cancelled. No charges were made to your account. Your cart items have been saved, so you can safely retry the payment whenever you're ready.</p>
          
          <div className="flex flex-col gap-4">
            <button 
              onClick={handleRetry} 
              disabled={retrying}
              className="flex justify-center items-center gap-2 bg-brand-darkSage text-white px-8 py-4 rounded-full uppercase tracking-widest text-xs font-bold hover:bg-brand-gold transition-all shadow-md disabled:opacity-70"
            >
              <FiRefreshCw className={retrying ? 'animate-spin' : ''} /> 
              {retrying ? 'Connecting to Gateway...' : 'Retry Payment'}
            </button>
            <button 
              onClick={() => navigate('/checkout')} 
              className="text-brand-darkSage font-bold text-xs uppercase tracking-widest hover:text-brand-gold transition-colors"
            >
              Return to Checkout
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PaymentCancel;